import { getAccessToken } from '../../../selectors/biasharaFlexi/payment';
import { getIsApiPending } from '../../../selectors/biasharaFlexi/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/biasharaFlexi/payloadCollection';
import { getCompanyIdValue, getQuoteIdValue } from '../../../selectors/biasharaFlexi/companyDetails';
import { getUploadDocumentsForm } from '../../../selectors/biasharaFlexi/uploadDocuments';
import axios from 'axios';
import { apiTransitionBiasharaFlexiUploadDocumentsForm } from '../../../actions/biasharaFlexi/uploadDocuments';

export const saveDocuments = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            store.dispatch(apiTransitionBiasharaFlexiUploadDocumentsForm.pending());
            try {
                const resp = await makeSubmission(store.getState());

                if (resp.data) {
                    store.dispatch(apiTransitionPayloadCollection.initial());
                    store.dispatch(apiTransitionBiasharaFlexiUploadDocumentsForm.success());
                }
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionPayloadCollection.initial());
                store.dispatch(apiTransitionBiasharaFlexiUploadDocumentsForm.failure());
            }
        }
    })();
    return next(action);
};

const payloadCollection = (state) => {
    const cid = getCompanyIdValue(state);
    const qid = getQuoteIdValue(state);
    const documents = getUploadDocumentsForm(state);

    const payload = {
        companyId: cid.value,
        quoteId: qid.value,
        companyIncorporationCertificate: documents.incorporationCertificate.value?.base64File,
        companyKraCertificate: documents.kraCertificate.value?.base64File,
    };

    return {
        ...payload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/biashara-flexi/upload-documents';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        throw e;
    }
};
